webpackJsonp([13],{

/***/ 1186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function warehouse(vm) {
	return vm.$resource('warehouse{/id}');
}

/* harmony default export */ __webpack_exports__["a"] = (warehouse);

/***/ }),

/***/ 1292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resource_warehouse__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_ButtonCreate__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_ButtonCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_ButtonCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_FilterList__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_FilterList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_shared_FilterList__);




var changePage = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(value) {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.page = value;
						this.loadData();

					case 2:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function changePage(_x) {
		return _ref.apply(this, arguments);
	};
}();

var changeState = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3) {
		var id = _ref3.id;
		var modelRow;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						modelRow = this.rows.filter(function (row) {
							return row.id === id;
						})[0];
						_context2.next = 3;
						return this.$http.patch('//products.japisale.com' + '/p/warehouses/' + id + '/flag-active', { flagActive: modelRow.flagActive });

					case 3:
						this.loadData();

					case 4:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function changeState(_x2) {
		return _ref2.apply(this, arguments);
	};
}();

var deleteRow = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6) {
		var id = _ref6.id;
		var error;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.prev = 0;
						_context3.next = 3;
						return this.$http.delete('//products.japisale.com' + '/p/warehouses/' + id);

					case 3:
						this.loadData();
						_context3.next = 10;
						break;

					case 6:
						_context3.prev = 6;
						_context3.t0 = _context3['catch'](0);
						error = _context3.t0.data;

						if (error.message === 'WAR_HAS_PRODUCTS') {
							this.showNotification('El minibar no se puede eliminar porque ya tiene productos', 'warning');
						}

					case 10:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[0, 6]]);
	}));

	return function deleteRow(_x3) {
		return _ref5.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var parameters, minibar, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						parameters = {
							page: this.page,
							limit: this.limit
						};

						if (this.flagActive || this.flagActive === 0) {
							parameters.flagActive = this.flagActive;
						}
						if (this.search) {
							parameters.search = this.search;
						}
						if (this.sortField) {
							parameters.sortField = this.sortField;
						}
						if (this.sortDirection) {
							parameters.sortDirection = this.sortDirection;
						}
						minibar = this.$route.name === 'minibar-list' ? 1 : 0;
						_context4.next = 8;
						return this.$http.get('//products.japisale.com' + '/p/warehouses?minibar=' + minibar, { params: parameters });

					case 8:
						response = _context4.sent;

						this.totalPages = Number(response.headers.get('x-last-page'));
						this.rows = response.data;
						this.loading = false;

					case 12:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this);
	}));

	return function loadData() {
		return _ref8.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







function mounted() {
	this.resource = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__resource_warehouse__["a" /* default */])(this);
	if (this.$route.name === 'warehouses-list') {
		this.buttonText = 'Almacén';
		this.createHref.name = 'warehouses-new';
		this.toTransferName = 'warehouses';
	} else {
		this.buttonText = 'Minibar';
		this.createHref.name = 'minibar-new';
		this.toTransferName = 'minibar';
	}
	this.loadData();
}

function columnSortableEvent(_ref4) {
	var id = _ref4.id;

	var self = this;
	var newColumn = self.columns.filter(function (column) {
		return column.id === id;
	});
	newColumn[0].isSortable = newColumn[0].isSortable.down ? { down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map(function (columnSingle) {
		var newColumnSingle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, columnSingle);
		if (columnSingle.isSortable) {
			if (columnSingle.id !== newColumn[0].id) {
				newColumnSingle.isSortable = { down: true, up: false };
			}
		}
		return newColumnSingle;
	});
	this.sortField = newColumn[0].code;
	this.sortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
	this.loadData();
}

function goToEdit(_ref7) {
	var id = _ref7.id;

	var editHref = { name: this.toTransferName + '-config', params: { minibarId: id } };
	this.$router.push(editHref);
}

function pagesVisible() {
	return this.totalPages < 5 ? this.totalPages : 5;
}

function searchByColumn(search) {
	this.search = search;
	this.page = 1;
	this.loadData();
}

function selectedFilter(filter) {
	this.filterValue = filter.id;
	if (filter.id === 2) {
		this.flagActive = 1;
		this.loading = true;
		this.page = 1;
		this.loadData();
	} else if (filter.id === 3) {
		this.flagActive = 0;
		this.loading = true;
		this.page = 1;
		this.loadData();
	} else {
		this.flagActive = null;
		this.loading = true;
		this.page = 1;
		this.loadData();
	}
}

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		ButtonCreate: __WEBPACK_IMPORTED_MODULE_6__components_shared_ButtonCreate___default.a,
		FilterList: __WEBPACK_IMPORTED_MODULE_7__components_shared_FilterList___default.a,
		TableRun: __WEBPACK_IMPORTED_MODULE_3_table_run___default.a
	},
	computed: {
		pagesVisible: pagesVisible
	},
	watch: {
		$route: function $route(newVal) {
			if (typeof newVal !== 'undefined') {
				this.loadData();
				if (newVal.name === 'warehouses-list') {
					this.buttonText = 'Almacén';
					this.createHref.name = 'warehouses-new';
					this.toTransferName = 'warehouses';
				} else {
					this.buttonText = 'Minibar';
					this.createHref.name = 'minibar-new';
					this.toTransferName = 'minibar';
				}
			}
		}
	},
	data: function data() {
		return {
			buttonText: '',
			columns: [{ id: 1, name: 'Code', code: 'code', isSortable: { down: false, up: false } }, { id: 2, name: 'Name', code: 'name', isSortable: { down: false, up: false } }, { id: 3, name: 'Room', code: '' }, { id: 4, name: '', code: '' }],
			createHref: {},
			filterValue: 1,
			flagActive: null,
			limit: 10,
			loading: false,
			page: 1,
			resource: null,
			rows: [],
			search: null,
			sortDirection: null,
			sortField: null,
			totalPages: 5,
			toTransferName: ''
		};
	},

	name: 'minibar',
	methods: {
		changePage: changePage,
		changeState: changeState,
		columnSortableEvent: columnSortableEvent,
		deleteRow: deleteRow,
		goToEdit: goToEdit,
		loadData: loadData,
		searchByColumn: searchByColumn,
		selectedFilter: selectedFilter
	},
	mixins: __WEBPACK_IMPORTED_MODULE_4__shared_mixins__["a" /* default */],
	mounted: mounted
});

/***/ }),

/***/ 1424:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".column-transfer[data-v-70a1f3dc]{position:absolute;right:158px}.column-transfer a i[data-v-70a1f3dc]{color:#2e394b;height:16px!important;margin-top:13px}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/minibar/List.vue"],"names":[],"mappings":"AACA,kCACE,kBAAmB,AACnB,WAAa,CACd,AACD,sCACI,cAAe,AACf,sBAAwB,AACxB,eAAiB,CACpB","file":"List.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.column-transfer[data-v-70a1f3dc] {\n  position: absolute;\n  right: 158px;\n}\n.column-transfer a i[data-v-70a1f3dc] {\n    color: #2e394b;\n    height: 16px !important;\n    margin-top: 13px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1509:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1424);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("5fb3188f", content, true);

/***/ }),

/***/ 1670:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "minibar"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md10": ""
    }
  }, [_c('filter-list', {
    staticClass: "mb-3",
    attrs: {
      "value": _vm.filterValue,
      "loading": _vm.loading
    },
    on: {
      "selected-filter": _vm.selectedFilter
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "md2": ""
    }
  }, [_c('button-create', {
    attrs: {
      "text": _vm.buttonText,
      "href": _vm.createHref
    }
  })], 1)], 1), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": true,
      "include-switch": true,
      "include-settings": true,
      "include-delete-single": true,
      "selectable": false,
      "switch-value": 'flagActive'
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn,
      "on-change-state": _vm.changeState,
      "on-delete-event": _vm.deleteRow,
      "go-to-edit-page": _vm.goToEdit
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.code_roomtype)), (props.row.code_roomtype && props.row.room_number) ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v(_vm._s(props.row.room_number))]), _vm._v(" "), _c('td', {
          staticClass: "column-transfer text-xs-right"
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: (_vm.toTransferName + "-products"),
              params: {
                id: props.row.id,
                name: props.row.name
              }
            }
          }
        }, [_c('v-icon', [_vm._v("input")])], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalPages),
      expression: "totalPages"
    }],
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "mt-3": ""
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": _vm.changePage
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1509)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1292),
  /* template */
  __webpack_require__(1670),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-70a1f3dc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/13.de2ea741894ca75b67b3.js